var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M113.5,10.4C85.8,14.1,60.8,26.7,42,46.6C28.3,61.1,18.2,79.2,13.4,97.9c-3.1,11.9-3.4,15.1-3.4,30c0,14.9,0.4,18.2,3.4,30c7.9,31,29.6,58.6,58,73.9c18.3,9.8,35.6,14.2,56.5,14.2c19.4,0,35.9-3.9,52.5-12.2c12.3-6.2,21.2-12.6,31-22.4c16.6-16.6,27.6-36.7,32.3-59.1c3.3-15.5,3.2-34.2-0.3-50.2c-5.7-26.4-22.2-52-44-68.4c-15.7-11.8-32.4-19-52.3-22.6C141.3,10.1,119.5,9.6,113.5,10.4z M139.2,25c52.2,5.7,92.2,50.3,92.2,103c0,57.1-46.4,103.5-103.5,103.5c-48.6,0-90.6-33.8-101.1-81.3C17.4,108.5,35.1,65,70.9,41.4c12.9-8.5,30-14.7,44.7-16.4C121.6,24.3,133.3,24.3,139.2,25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M123.8,62.6c-7,2.2-11,8-10.5,15.4c0.9,12.4,15.8,17.9,24.7,9c3.2-3.2,4.1-5.4,4.1-10.6c0-3.9-0.2-4.7-1.4-6.9C137.1,63.4,130.3,60.6,123.8,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M105.8,105.9c-0.2,0.2-0.4,5.2-0.4,11.2v10.8h7.5h7.5V150v22.1l-7.4,0.2l-7.4,0.2l-0.2,11l-0.1,11.1h26h26v-11.2v-11.2H150h-7.5v-33.3v-33.3h-18.1C114.3,105.5,106,105.7,105.8,105.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.25b830e178e279227786c4f2cd2e0aa7.svg";
export { ForwardRef as ReactComponent };